<template>
  <table class="login-table">
    <tr>
      <td>
        <a href="http://liuxue.xdf.cn/Evaluation/">
          <div class="icon">
            <i style="background-position: 5px 3px"></i>
          </div>
          <div class="title">免费评估</div>
        </a>
      </td>
      <td>
        <a href="http://hutuyu.cn/?utm_source=jituanguanwang&utm_medium=goabroad&utm_term=youcejiugongge&utm_content=youcejiugongge&utm_campaign=youcejiugongge">
          <div class="icon">
            <i style="background-position: -83px 3px"></i>
          </div>
          <div class="title">海外院校</div>
        </a>
      </td>
      <td>
        <a href="http://goabroad.xdf.cn/zhuanti/universityrankings/index.html">
          <div class="icon">
            <i style="background-position: -168px 3px"></i>
          </div>
          <div class="title">院校排名</div>
        </a>
      </td>
    </tr>
    <tr>
      <td>
        <a href="http://liuxue.xdf.cn/case/">
          <div class="icon">
            <i style="background-position: 5px -107px"></i>
          </div>
          <div class="title">成功案例</div>
        </a>
      </td>
      <td>
        <a href="http://www.xdf.cn/zhuanti/kaoshiyueli.html">
          <div class="icon">
            <i style="background-position: -83px -107px"></i>
          </div>
          <div class="title">考试月历</div>
        </a>
      </td>
      <td>
        <a href="http://liuxue.xdf.cn/Product/index.shtml">
          <div class="icon">
            <i style="background-position: -168px -107px"></i>
          </div>
          <div class="title">留学方案</div>
        </a>
      </td>
    </tr>
    <tr>
      <td>
        <a href="http://youxue.xdf.cn/mingxiao/?utm_source=goabroad.xdf.cn/xinban&utm_medium=affiliate&utm_term=mingxiao&utm_content=mingxiaokaocha&utm_campaign=pc">
          <div class="icon">
            <i style="background-position: 5px -218px"></i>
          </div>
          <div class="title">名校考察</div>
        </a>
      </td>
      <td>
        <a :href="dxlyLink">
          <div class="icon">
            <i style="background-position: -83px -218px"></i>
          </div>
          <div class="title">冬夏令营</div>
        </a>
      </td>
      <td>
        <a href="http://souke.xdf.cn/">
          <div class="icon">
            <i style="background-position: -168px -218px;"></i>
          </div>
          <div class="title">快捷报班</div>
        </a>
      </td>
    </tr>
  </table>
</template>

<script>
export default {
  name: 'Logintable',
  data () {
    return {
      dxlyLink:window.dxlyLink||'http://youxue.xdf.cn?utm_source=xdf&utm_medium=affiliate&utm_term=2020_summer&utm_content=4words&utm_campaign=index',
    }
  },
}
</script>

<style lang="stylus" scoped>
@import '~styles/varibles.styl'
.login-table
  height: 335px
  width: 100%
  display: flex
  flex-direction: column
  border-top: 1px solid #eee
  border-left: 1px solid #eee
  border-collapse: collapse
  tr
    flex: 1
    display: flex
    td
      flex: 1
      display: flex
      height: 111px
      flex-direction: column
      border-right: 1px solid #eee
      border-bottom: 1px solid #eee
      a
        display: flex
        flex-direction: column
        height: 100%
        width: 100%
        color: #666
        .icon
          flex: 3
          position: relative
          i
            position: absolute
            display: block
            width: 40px
            height: 40px
            top: 50%
            left: 50%
            margin-left: -20px
            margin-top: -8px
            background: url(http://www.xdf.cn/zhuanti/liuxuenew/img/icontable@6.png) no-repeat
        .title
          flex: 2
          padding-top 9px
          text-align: center
      &:hover
        .title
          color: $themeColor
      .icon
        flex: 2
        position: relative
        i
          position: absolute
          display: block
          width: 40px
          height: 40px
          top: 50%
          left: 50%
          margin-left: -20px
          margin-top: -20px
          background: url(http://images.xdf.cn/school/middleschool/static/images/sprite.png) no-repeat
        .title
          flex: 1
          color: #666
          text-align: center
          a
            display: inline
            &:hover
              color: #31a893
</style>



// WEBPACK FOOTER //
// src/pages/gobroad/components/swiper/components/Logintable.vue